import { render, staticRenderFns } from "./m-page-view.vue?vue&type=template&id=421c09eb&scoped=true&"
import script from "./m-page-view.vue?vue&type=script&lang=js&"
export * from "./m-page-view.vue?vue&type=script&lang=js&"
import style0 from "./m-page-view.vue?vue&type=style&index=0&id=421c09eb&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c09eb",
  null
  
)

export default component.exports